import { useEffect, useState } from 'react';

/**
 * Mirrors `active`, but only once it has stayed true for `delayMs`.
 *
 * A load that resolves in a couple of hundred milliseconds should show no loading state at all:
 * an indicator that appears and vanishes reads as a glitch rather than as progress. Holding it
 * back keeps the fast path silent and surfaces an indicator only when the wait is long enough
 * to be worth explaining.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return;
    }

    const timer = window.setTimeout(() => setVisible(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [active, delayMs]);

  return visible;
}
